import {
  ACCOUNT_UPDATE,
  ACCOUNT_UPDATE_ASYNC_START,
  ACCOUNT_FETCH,
  ACCOUNT_FETCH_ASYNC_START,
  SETTLEMENT_LOOKUP,
  WITHDRAW_SETTLEMENT,
} from '../types';
import { showToast } from './toast';
import Bank from '../../services/cashout';

export const updateAccountInfo =
  (details, onFinish = () => {}) =>
  async (dispatch, getState) => {
    try {
      const {
        common: {
          user: { merchantId },
        },
      } = getState();
      dispatch({
        type: ACCOUNT_UPDATE_ASYNC_START,
      });

      let { data } = await Bank.updateAccountDetails(details, merchantId);

      dispatch(showToast('success', 'Account details updated successfully'));

      dispatch({
        type: ACCOUNT_UPDATE,
      });
      onFinish();
      return data;
    } catch (err) {
      onFinish();
      dispatch({
        type: ACCOUNT_UPDATE,
      });
      dispatch(
        showToast(
          'error',
          err?.response?.data?.message || 'Something went wrong',
        ),
      );
    }
  };

export const fetchAccounts =
  (onFinish = () => {}) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: ACCOUNT_FETCH_ASYNC_START,
      });
      const {
        common: {
          user: { merchantId },
        },
      } = getState();

      let { data } = await Bank.fetchAccountDetails(merchantId);
      onFinish();
      dispatch({
        type: ACCOUNT_FETCH,
        payload: data,
      });
      return data;
    } catch (err) {
      onFinish();
      dispatch({
        type: ACCOUNT_UPDATE,
        payload: [],
      });
      dispatch(
        showToast(
          'error',
          err?.response?.data?.message || 'Something went wrong',
        ),
      );
    }
  };

export const lookupSettlement =
  (date, onFinish = () => {}) =>
  async (dispatch, getState) => {
    try {
      const {
        common: {
          user: { merchantId },
        },
      } = getState();

      let { data } = await Bank.lookupSettlement(merchantId, date);
      onFinish(data.data.amount);
      return data;
    } catch (err) {
      onFinish();
      dispatch(
        showToast(
          'error',
          err?.response?.data?.message || 'Something went wrong',
        ),
      );
    }
  };

export const withdrawSettlement =
  (body, onFinish = () => {}, onFail = () => {}) =>
  async (dispatch, getState) => {
    try {
      const {
        common: {
          user: { merchantId },
        },
      } = getState();

      await Bank.withdrawSettlement(merchantId, body);
      onFinish();
    } catch (err) {
      onFail();
      dispatch(
        showToast(
          'error',
          err?.response?.data?.message || 'Something went wrong',
        ),
      );
    }
  };
